// @ts-nocheck
import { trackPDFDownload } from './saga/AnalyticsSaga';
import { filterPDCBySelectedDrivers, loadObjectTreeSaga } from './saga/ObjectTreeSaga';
import {
    downloadPdcAttachmentSaga,
    fetchInspectionsSaga,
    fetchInspectionsSummarySaga,
    fetchMoreInspectionsSaga,
    loadPdcInformationSaga,
    loadPdfSaga,
} from './saga/PDCSaga';
import { downloadProductActivationsSaga } from './saga/ProductActivationSaga';

export const combinedSagas = [
    downloadPdcAttachmentSaga,
    fetchInspectionsSaga,
    fetchInspectionsSummarySaga,
    fetchMoreInspectionsSaga,
    loadPdcInformationSaga,
    downloadProductActivationsSaga,
    loadPdfSaga,
    trackPDFDownload,
    loadObjectTreeSaga,
    filterPDCBySelectedDrivers,
];

export function runSagas(middleware) {
    combinedSagas.forEach(saga => {
        middleware.run(saga);
    });
}
